export default __webpack_public_path__ + "static/avatar-aca7261cad4246c5e17b003fb6afadb8.png";